import React, { useState, useEffect } from "react";
import { Navbar, Nav, Container, Offcanvas } from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import techcognics from "../../assets/techcognics_logo.png";
import ContactSalesModal from "../../component/ContactSalesModal";
import "./header.css";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

const SECTIONS = ["home", "why-hrms","features","pricing"];


const ErpLandingHeader = () => {
    const location = useLocation();
    const navigate = useNavigate();

    const [showContactModal, setShowContactModal] = useState(false);
    const [showOffcanvas, setShowOffcanvas] = useState(false);
    const [activeLink, setActiveLink] = useState("home");


    useEffect(() => {
        if (showContactModal && location.hash) {
            navigate(location.pathname, { replace: true });
        }
    }, [showContactModal, location, navigate]);


    useEffect(() => {
        const onScroll = () => {
            const scrollPos = window.scrollY + 120;
            let current = "home";

            SECTIONS.forEach((id) => {
                const section = document.getElementById(id);
                if (section && section.offsetTop <= scrollPos) {
                    current = id;
                }
            });

            setActiveLink(current);
        };

        window.addEventListener("scroll", onScroll);
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    /* -------------------------
       Smooth scroll handler
    -------------------------- */
    const handleScroll = (id) => {
        const section = document.getElementById(id);
        if (section) {
            section.scrollIntoView({ behavior: "smooth", block: "start" });
        }
        setActiveLink(id);
        setShowOffcanvas(false);
    };

    return (
        <>
            <Navbar expand="lg" className="hrms-landing-header">
                <Container fluid className="px-lg-5 px-md-5">
                    {/* LOGO */}
                    <Navbar.Brand as={Link} to="/" 
                    
                    >
                        <img src={techcognics} alt="Techcognics" className="erp-logo" />
                    </Navbar.Brand>

                    {/* MOBILE TOGGLE */}
                    <Navbar.Toggle
                        aria-controls="offcanvasNavbar"
                        aria-expanded={showOffcanvas}
                        onClick={() => setShowOffcanvas(true)}
                    />

                    {/* DESKTOP NAV */}
                    <Navbar.Collapse className="justify-content-end d-none d-lg-flex">
                        <Nav className="ms-auto gap-lg-4 align-items-center">
                            {SECTIONS.map((item) => (
                                <Nav.Link
                                    key={item}
                                    href={`#${item}`}
                                    className={activeLink === item ? "active" : ""}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        handleScroll(item);
                                    }}
                                >
                                    {item.charAt(0).toUpperCase() + item.slice(1)}
                                </Nav.Link>
                            ))}
                            <button onClick={() => setShowContactModal(true)} className="btn-two-header-hrms">
                                Talk To Sales <span className="btn-icon"><ArrowForwardIcon fontSize="small" /></span>
                            </button>
                        </Nav>
                    </Navbar.Collapse>

                    {/* MOBILE OFFCANVAS */}
                    <Offcanvas
                        id="offcanvasNavbar"
                        show={showOffcanvas}
                        onHide={() => setShowOffcanvas(false)}
                        placement="end"
                        className="mobile-sidebar"
                    >
                        <Offcanvas.Header closeButton>
                            <Offcanvas.Title>
                                <img src={techcognics} alt="Techcognics" className="erp-logo" />
                            </Offcanvas.Title>
                        </Offcanvas.Header>

                        <Offcanvas.Body>
                            <Nav className="flex-column">
                                {SECTIONS.map((item) => (
                                    <Nav.Link
                                        key={item}
                                        className={activeLink === item ? "active" : ""}
                                        href={`#${item}`}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            handleScroll(item);
                                        }}
                                    >
                                        {item.charAt(0).toUpperCase() + item.slice(1)}
                                    </Nav.Link>
                                ))}

                                <button
                                    className="hrms-cta-btn-header text-start w-100"
                                    onClick={() => {
                                        setShowContactModal(true);
                                        setShowOffcanvas(false);
                                    }}
                                >
                                    Talk To Sales
                                </button>
                            
                            </Nav>
                        </Offcanvas.Body>
                    </Offcanvas>
                </Container>
            </Navbar>

            {/* CONTACT MODAL */}
            <ContactSalesModal
                show={showContactModal}
                onClose={() => setShowContactModal(false)}
            />
        </>
    );
};

export default ErpLandingHeader;
